import React from 'react';
import './PortfolioSection.css';
import img1 from '../assets/img1.png';
import img2 from '../assets/img2.png';
import img3 from '../assets/img3.png';

const portfolioProjects = [
  {
    image: img1,
    name: 'OneAIChat',
    url: 'https://oneaichat.com/',
    desc: 'A next-gen AI chat platform integrating multiple LLMs (GPT, open-source, custom-trained models). Provides model selection, subscription management, SSO/login, and real-time chat. Scalable SaaS for individuals & enterprises.',
    stack: 'React, Node.js, Express, MongoDB, OpenAI & custom LLMs',
  },
  {
    image: img2,
    name: 'Chocstar.nl',
    url: 'https://chocstar.nl/',
    desc: 'Chocstar.nl is a Netherlands-based e-commerce store for personalized, handmade chocolates. I built a fast, responsive platform enabling users to customize chocolate gifts with messages, logos, and packaging. Optimized product display, checkout, and mobile UX. Features include B2B gifting, logo branding, and same-day shipping integration.',
    stack: 'Next.js, React, Node.js, MongoDB, Stripe, Responsive Web Design',
  },
  {
    image: img3,
    name: 'HeliosWatchStore.com',
    url: 'https://helioswatchstore.com/',
    desc: 'Worked on HeliosWatchStore.com, an online shop specializing in luxury, fashion, and designer watches. Improved UX by redesigning product category pages, refining browsing & filtering, and optimizing checkout. Ensured superb mobile/tablet experience, implemented secure payments, and optimized site speed for better conversions.',
    stack: 'Next.js, React, Node.js, Headless CMS, Responsive Web, Payment Gateway',
  },
];

const Portfolio: React.FC = () => (
  <section className="portfolio-cn-section">
    <div className="portfolio-badge">Our Portfolio</div>
    <h2 className="portfolio-title gradient-text">Let’s See Our Best Work</h2>
    <div className="portfolio-lead">
      We build next-gen digital products for a changing world. <br className="hide-on-mobile" />Here’s a few projects that showcase our talent for innovation, design, and seamless execution.
    </div>
    <div className="portfolio-grid">
      {portfolioProjects.map((project, i) => (
        <div className="portfolio-card" key={project.name}>
          <div className="portfolio-img" style={{backgroundImage:`url('${project.image}')`}}></div>
          <div className="portfolio-meta">
            {project.url ? (
              <a href={project.url} className="portfolio-project-name gradient-text" target="_blank" rel="noopener noreferrer">{project.name}</a>
            ) : (
              <div className="portfolio-project-name gradient-text">{project.name}</div>
            )}
            <div className="portfolio-desc">{project.desc}</div>
            <div className="portfolio-stack">{project.stack}</div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default Portfolio;
